<script>
    import {sgettext} from '../../i18n.js';
    export let row = {};
    const SAP_STATUS = {
		FINAL: sgettext('$$FINAL$$'),
		PARTIAL: sgettext('$$PARTIAL$$'),
		NONE: ''
	};
</script>

{#if row.operation_confirmation === SAP_STATUS.FINAL}
    <span class="badge sap-status sap-status-sent">{SAP_STATUS.FINAL}</span>
{:else if row.operation_confirmation === SAP_STATUS.PARTIAL}
    <span class="badge sap-status sap-status-pending">{SAP_STATUS.PARTIAL}</span>
{:else if row.operation_confirmation === SAP_STATUS.NONE}
    <span style="margin-left:15px;">-</span>
{/if}

<style>
    .sap-status {
		box-sizing: border-box;
		border-radius: 6px;
		padding: 4px 10px;
		margin: 3px 3px;
	}

	.sap-status-sent {
		color: white;
		background-color: #25a745;
	}

	.sap-status-pending {
		color: white;
		background-color: #059cdf;
	}
</style>
